export default "__VITE_ASSET__BR_Lnik1__"